import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>The JD Group is a leading multichannel retailer of sports
        and outdoor fashion brands. The business is a significant contributor and collector of taxes
        including employment taxes, indirect taxes, corporate income taxes and property related
        taxes.
        <br />
        <br />
        The JD Group is committed to complying with tax law and practice in all territories in which
        it operates, including the UK, which is its main place of business.
        <h2>1. Attitude Towards Tax Planning</h2>When structuring commercial activities,
        consideration is given, along with other factors, to the prevailing tax laws in the relevant
        jurisdiction.
        <br />
        <br />
        Any tax planning undertaken has commercial and economic substance and will utilise available
        tax incentives, reliefs and exemptions in line with, and in the spirit of, the governing tax
        legislation.
        <br />
        <br />
        The Group aims to ensure that it pays the right amount of tax in each country in which it
        operates and does not engage in arrangements which are artificial or contrived.
        <br />
        <br />
        Transactions between Group companies are undertaken in accordance with current OECD
        principles.<h2>2. Level of Tax Risk Accepted</h2>The JD Group is a multinational
        organisation and, as such, may be exposed to a variety of tax risks.
        <br />
        <br />
        The Group identifies, evaluates, manages and monitors tax risks where appropriate and
        strives to be low risk.
        <br />
        <br />
        Where there is significant uncertainty or complexity in relation to risk, external advice
        may be sought from professional advisors and discussed with the relevant tax authority.
        <h2>3. Approach to Dealing with Tax Authorities</h2>The Group is committed to working in a
        collaborative and transparent way with the tax authorities in the countries in which it
        operates in order to minimise the risk of challenge and dispute.
        <br />
        <br />
        In the UK, the Group is in regular dialogue with its Customer Relationship Manager at HMRC
        to update them on significant transactions, changes in the business and to seek advice at an
        early stage in respect of any tax issues.
        <h2>4. Approach to Tax Risk Management and Governance Arrangements</h2>The Group has a
        dedicated in-house team that has responsibility for Corporate Tax, Employment Taxes, VAT,
        Customs and Duties. All hold the appropriate professional qualifications commensurate to
        their role and responsibilities.
        <br />
        <br />
        The Group Chief Financial Officer, in conjunction with his role as Senior Accounting
        Officer, owns the approach to tax which is approved by the Board of Directors.
        <br />
        <br />
        The Group Head of Tax is responsible for implementing, maintaining and reviewing the
        supporting policies to mitigate tax risk and ensure compliance.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/tax-strategy.jpg',
    body: Body,
};
